import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Benign browser notice (Radix Select inside dialogs); keep the dev overlay from treating it as a crash
window.addEventListener("error", (e) => { if (String(e.message || "").includes("ResizeObserver loop")) { e.stopImmediatePropagation(); e.preventDefault(); } });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
